import React,{useState, useEffect} from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { attendeeRegisterURL, WorkshopPublicURL } from "../../../apis/urls";
import Loader from "../../../common-components/loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";
import moment from "moment/moment";
import { Table, Toggle,Pagination } from "rsuite";

const { Column, HeaderCell, Cell } = Table;

const AttendeeRegisteringWorkshop = () => {

    useEffect(() => {
        setLoader(true);
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });
    }, []);

    const [loader,setLoader] = useState(true);
    const [result,setResult] = useState([]);
    const [aresult,setAResult] = useState([]);

    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);

    const [added, setAdded] = useState(false);

    const  [regname, setRegName] = useState('');

    let {regid} = useParams();


    let counts = 0;
    if(result)
    {
        counts = result.length;
    }

    useEffect(() => {

        if(added == true){

            const notify = () => toast.success("Removed Successfully!..", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 500
              });

              notify();
        }
      }, [added])

    let navigate = useNavigate();

    const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: WorkshopPublicURL+'regattendee/list/'+regid+'?page='+0+'&size='+10,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{

            console.log("daaaas",response.data.data);

            setResult(response.data.data.items);
            setCurrentpage(response.data.data.currentPage)
            setTotalPages(response.data.data.totalPages)
            setTotalItems(response.data.data.totalItems)
            setLoader(false)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }





    let sl =1;
    return (
        <div className="wrapper">

            <aside className="right-side ">
                <div class="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            <i className="icon-suitcase1"></i>
                            <h2 className="page-title">Attendees</h2>
                        </div>
                        {/* <div className="page-rightside-action-column">
                        <div class="input-groups mt-3 mb-3 search-grp">
                                <div class="input-group-prepends">
                                <select class="form-controls custom-select" onChange={onChangeSearchTitles}>
                                        <option value="none" selected disabled hidden>STATUS</option>
                                        <option value=" ">ALL</option>
                                        <option>ACTIVE</option>
                                        <option>INACTIVE</option>
                                        <option>DELETE</option>
                                    </select> 
                                </div>
                                <input type="text" 
                                class="form-controls search-bar"             
                                value={searchTitle}
                                onChange={onChangeSearchTitle}
                                placeholder="Search" />
                                <button class="btn btn-search icon-search"></button>
                                </div>
                            
                            <Link to="/add_event" data-toggle="tooltip" title="" class="addbtnitem-link text-anchor" data-original-title="Add New Event"><i class="icon-add"></i><span>Add New Event</span> </Link>

                        </div> */}
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><Link to="/workshop">Events and Workshops</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Event Registers</li>

                        </ol>
				    </nav>


                    <div className="jobs-list-wrpr list-wrpr">




                        {result?(
                        result?.map((item,index) =>
                            (
                                <div className="list " key={index}>
                                    <div className="row">

                                        <div className="col-md-1">
                                        <div class="jobs-user">
                                            Sl.No
                                            <span class="desig">{sl++}</span>
                                        </div>
                                        </div>

                                        
                                        <div className="col-md-5">
                                            <div className="jobs-user">
                                                Name
                                                <span class="desig"> {decode(item.firstname)}</span>
                                            </div>
                                        </div>

                                        <div className="col-md-5">
                                            <div className="jobs-user">
                                            Phone & Email
                                                <span class="desig"> {item.phone}<br />
                                                </span>    
                                            </div>
                                        </div>
                                        {/* <div className="col-md-3">
                                            <div className="jobs-user">
                                            Register Name
                                                <span class="desig"> 
                                                    {regname}
                                                </span>    
                                            </div>
                                        </div> */}


                                    
                                        <div className="col-md-1">
                                            <div className="list-action-wrpr text-right  roundicons-text">

                                                <Link  to={"/attendee_view/"+item.eventid+"/"+item.id} data-toggle="tooltip" title="View" ><i className="edit icon-eye"></i><span>Views</span></Link>  

                                            </div>
                                        </div>
                                        {/* <div>
                                            <ToastContainer
                                                style={{width: 578, marginTop: '10%', marginLeft: '8.3%'}}
                                                toastStyle={{backgroundColor: "#e74c3c", color: 'white', fontSize: 16}}
                                                progressStyle={{backgroundColor: 'white'}} 
                                            />
                                        </div> */}
                                    </div>
                                </div>
                            )

                        )):null
                        }
                        {
                            !result.length?
                            (<div className="nodata">
                                <h2>Sorry! No Result Found</h2>
                            </div>):null
                        }


    
                    </div>

                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }
{/* 
                    {result?(
                    <div class="pagination-wrpr">
                            <ReactPaginate
                                className="pagination page"
                                pageClassName="page-item"
                                activeClassName="active"
                                nextLabel=">"
                                previousLabel="<"
                                previousClassName="page-link p-link"
                                nextClassName="page-link p-link"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={10}
                                pageCount={totalPages}
                                renderOnZeroPageCount={1}
                            />
                        </div>):null
                        }  */}


                </div>
            </aside>





        </div>
    )
}

export default AttendeeRegisteringWorkshop;